import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToastController, AlertController } from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { ImageSelectorProvider } from '../../providers/image-selector/image-selector';
import { MediaSelectorProvider } from '../../providers/image-selector/media-selector';

@Component({
  selector: 'edit-place-review',
  templateUrl: 'edit-place-review.html',
})
export class EditPlaceReviewComponent {
  log = debug('app:EditPlaceReviewComponent');
  @Input() place: any;
  @Output() closeSubmitReviewComponent = new EventEmitter<boolean>();
  @Input() noModal = false;

  review: any = {};

  reviewText = '';
  recommended;

  loading = true;

  constructor(
    public toastCtrl: ToastController,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public userService: UserProvider,
    public imageSelector: ImageSelectorProvider,
    public alertCtrl: AlertController,
    public mediaSelector: MediaSelectorProvider,
  ) {}
  ngOnInit(): void {
    this.getUsersReview();
  }
  submitReview() {
    this.loading = true;
    this.updateReviewObject();
    if (!this.isReviewValid()) {
      return;
    }
    this.saveReviewToServer().then(res => {
      if (_.get(res.data, 'place')) {
        this.syncronizeLocalPlaceObjectWithServer(_.get(res.data, 'place'));
      }
    });
  }
  private saveReviewToServer() {
    const reviewId = _.get(this.review, '_id');
    this.log('ReviewId: ', reviewId);
    if (reviewId) {
      return this.crudApi
        .put(`/api/reviews/${reviewId}`, this.review)
        .then(res => {
          _.merge(this.review, res.data);
          this.emitCloseSubmitReivewComponent();

          return res;
        });
    } else {
      return this.crudApi.post(`/api/reviews`, this.review).then(res => {
        this.log('response: ', res);
        _.merge(this.review, res.data);
        this.emitCloseSubmitReivewComponent();
        if (_.size(_.get(this.review, 'photos'))) {
          this.tools.logAnalyticsEvent('trackCustom', 'created-review-with-photo');
          this.tools.logAnalyticsEvent('trackCustom', 'created-review');
          this.tools.logEventAndFlush('reviewWithPhoto');
          this.tools.logEventAndFlush('review');
        } else {
          this.tools.logAnalyticsEvent('trackCustom', 'created-review');
          this.tools.logEventAndFlush('review');
        }
        return res;
      });
    }
  }
  private emitCloseSubmitReivewComponent() {
    this.closeSubmitReviewComponent.emit();
    const toast = this.toastCtrl.create({
      message: 'Your review has been submitted to the CDLLife team for review',
      duration: 3000,
    });
    toast.present();
  }
  private syncronizeLocalPlaceObjectWithServer(placeId) {
    this.crudApi.get(`/api/places/${placeId}`).then(place => {
      _.merge(this.place, place.data);
      this.log('syncronizedLocalPlaceObjectWithServer');
    });
  }
  private getUsersReview() {
    this.crudApi
      .get(`/api/reviews/`, {
        place: this.place._id,
        user: this.userService.get('_id'),
      })
      .then(res => {
        if (_.size(res.data)) {
          this.log('getUsersReview Response: ', res.data);
          this.review = _.head(res.data);
          if (this.isReviewValid) {
            this.syncronizeReviewWithViewControls();
          }
        }
      });
  }
  private syncronizeReviewWithViewControls() {
    this.recommended = _.get(this.review, 'recommended', null);
    this.reviewText = _.get(this.review, 'review', '');
  }
  private updateReviewObject() {
    if (!this.review) {
      this.review = {};
    }
    _.set(this.review, 'place', _.get(this.place, '_id') || null);
    _.set(
      this.review,
      'googlePlaceId',
      _.get(this.place, 'locationMetadata.googlePlaceId') || null
    );
    _.set(this.review, 'recommended', _.get(this, 'recommended'));
    _.set(this.review, 'review', _.get(this, 'reviewText'));
    this.log('updatedReviewObject: ', this.review);
  }
  private isReviewValid(): Boolean {
    if (!_.size(this.review.place) && !_.size(this.review.googlePlaceId)) {
      console.warn(
        'review not submitted: no placeId or googlePlaceId',
        this.place,
        this.review
      );
      return false;
    } else if (
      this.review.recommended !== true &&
      this.review.recommended !== false
    ) {
      const alert = this.alertCtrl.create({
        title: 'Missing Rating!',
        subTitle:
          'Please use the thumbs up or thumbs down icon in order to rate your experience.',
        buttons: [
          {
            text: 'OK',
            cssClass: 'alert-button-ok',
            handler: () => {},
          },
        ],
      });
      alert.present();
    } else {
      return true;
    }
  }

  async addImageAction() {
    event.stopImmediatePropagation();
    if (window.location.port === '8100') {
      this.savePhotoToPlaceApi(
        'https://d2z5cdom2mbuj5.cloudfront.net/uploads/1563299505427823.jpg'
      );
      this.addPhotoToReview(
        'https://d2z5cdom2mbuj5.cloudfront.net/uploads/1563299505427823.jpg'
      );
    } else {
      const files = await this.mediaSelector.getMediaByType('photos');
      this.log('files', files);
      this.savePhotoToPlaceApi(_.get(_.head(files), 'url'));
      this.addPhotoToReview(_.get(_.head(files), 'url'));
      this.tools.logAnalyticsEvent(
        'trackCustom',
        'uploaded-location-photo'
      );
    }
  }
  private addPhotoToReview(url) {
    const photos = _.get(this.review, 'photos', []);

    photos.push({
      url: url,
      timestamp: Date.now(),
    });

    _.set(this.review, 'photos', photos);

    const toast = this.toastCtrl.create({
      message: 'Your photo has been added to the review',
      position: 'top',
      duration: 2500,
    });
    toast.present();
  }
  private savePhotoToPlaceApi(url) {
    const placeId = _.get(this.place, '_id');
    if (!placeId) {
      return;
    }
    this.crudApi
      .put(`/api/places/${placeId}/photos`, { url: url })
      .then(res => {
        this.log('uploaded image: ', res.data);
        this.addPhotoToLocalPlaceObject(url);
      });
  }
  private addPhotoToLocalPlaceObject(url) {
    let photosArray = _.get(this.place, 'photos.uploadedPhotos');
    if (!photosArray) {
      _.set(this.place, 'photos.uploadedPhotos', []);
      photosArray = _.get(this.place, 'photos.uploadedPhotos');
    }
    photosArray.push({
      url: url,
      user: this.userService.get('_id'),
      timestamp: Date.now,
    });
  }

  closeEditPlaceReview() {
    this.log('closeEditPlaceReview');
    this.closeSubmitReviewComponent.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/components/edit-place-review/edit-place-review.ts